import { Box, styled } from '@mui/material';

/*.circular-chart {
position: ' absolute;
  display: ' block;
  width: '38px;
  height: ' 38px;
  top: '-4px
}

.circle {
  stroke: ' #3DB37B;
  fill: ' none;
  stroke-width: ' 4px;
  stroke-linecap: ' round;
  animation: ' progress 1s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: ' 0 100;
  }
}*/

export const Ring = styled(Box)((props) => ({
	borderRadius: '50%',
	width: '38px',
	height: '38px',
	textAlign: 'center',
	border: '4px solid #CBDCDE',
	position: 'relative',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	'& .circular-chart': {
		position: 'absolute',
		display: 'block',
		width: '38px',
		height: '38px',
		top: '-4px',
		'& .circle': {
			stroke: ' #3DB37B',
			fill: 'none',
			strokeWidth: ' 4px',
			strokeLinecap: ' round',
			animation: ' progress 1s ease-out forwards',
		},
		'@keyframes progress': {
			'0%': {
				strokeDasharray: ' 0 100',
			},
		},
	},
}));
